export const LogoDinersClub = () => {
  return (
    <svg
      width="54"
      height="42"
      viewBox="0 0 54 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.4062 4.5C31.5 4.5 38.9062 11.9062 38.9062 21C38.9062 30.0938 31.5 37.5 22.4062 37.5C13.3125 37.5 5.90625 30.0938 5.90625 21C5.90625 11.9062 13.3125 4.5 22.4062 4.5ZM18.6562 30.75V11.25C14.8125 12.75 12 16.5938 12 21C12 25.5 14.8125 29.25 18.6562 30.75ZM26.1562 30.75C30.0938 29.25 32.9062 25.5 32.9062 21C32.9062 16.5938 30.0938 12.75 26.1562 11.25V30.75ZM49.5 0C51.9375 0 54 2.0625 54 4.5V37.5C54 40.0312 51.9375 42 49.5 42H4.5C1.96875 42 0 40.0312 0 37.5V4.5C0 2.0625 1.96875 0 4.5 0H49.5ZM30.8438 39C40.6875 39 49.6875 31.0312 49.6875 21.1875C49.6875 10.5 40.6875 3 30.8438 3H22.4062C12.4688 3 4.21875 10.5 4.21875 21.1875C4.21875 31.0312 12.4688 39 22.4062 39H30.8438Z"
        fill="white"
      />
    </svg>
  );
};
